import { ReturnZodSchema } from "@redotech/redo-model/return";
import { ReturnTableInputSchema } from "@redotech/redo-model/returns/return-table-input-schema";
import {
  OpensearchPaginationCursorSchema,
  PaginationCursorSchema,
} from "@redotech/redo-model/tables/table";
import { ReturnBearCaseMethodType } from "@redotech/returnbear-model/shared/common-enums";
import { sinkValue } from "@redotech/util/type";
import * as z from "zod/v4";

// Needed for type resolution
sinkValue(ReturnBearCaseMethodType);

const getReturnsPaginationOutput = z.object({
  // this is currently parsed and logged in the handler as a zod schema.
  // TODO: type this once we don't see any errors
  returns: z.array(z.union([ReturnZodSchema, z.any()])),
  total: z.number(),
  paginationToken: PaginationCursorSchema.nullish(),
  opensearchToken: OpensearchPaginationCursorSchema.nullish(),
});

const getReturnsPaginationInput = ReturnTableInputSchema.extend({
  pageNumber: z.number().optional(),
  pageSize: z.number(),
  paginationToken: PaginationCursorSchema.nullish(),
  opensearchToken: OpensearchPaginationCursorSchema.nullish(),
});

export const getReturnsPagination: {
  input: typeof getReturnsPaginationInput;
  output: typeof getReturnsPaginationOutput;
  name: "getReturnsPagination";
} = {
  name: "getReturnsPagination" as const,
  input: getReturnsPaginationInput,
  output: getReturnsPaginationOutput,
};
